import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnzCampaignPageVariant1Component } from '../views/campaign-page-variant1/campaign-page-variant1.component';
import { AnzCampaignPageComponent } from '../views/campaign-page/campaign-page.component';
import { anzCampaignPageRoutes } from './anz-campaign-page.routes';

@NgModule({
  declarations: [AnzCampaignPageComponent, AnzCampaignPageVariant1Component],
  imports: [
    RouterModule.forChild(anzCampaignPageRoutes),
    CommonModule,
    RouterModule,
  ],
})
export class AnzCampaignPageModule {}
